
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/phone/mypage/creditcard_edit",
      function () {
        return require("private-next-pages/phone/mypage/creditcard_edit.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/phone/mypage/creditcard_edit"])
      });
    }
  